import {LegacyPhoneListAdaptor} from './legacyPhoneListAdaptor.js';

export var LegacyAccountPersonAdaptor = function(personData) {
    var person = {};
    
    // Constructor
    if (personData) {
        person.email = personData.email;
        person.firstName = personData.names.getAName().given;
        person.lastName = personData.names.getAName().family;
        person.fID = personData.fID;
        person.personID = personData.id;
        person.personType = personData.type;
        person.profileThumbnailUrl = personData.profileThumbnailUrl;
        person.phoneList = LegacyPhoneListAdaptor(personData.phoneNumbers);
    }

    // -----------------------------------------------------
    //
    //                 Public Methods
    //
    // -----------------------------------------------------

    // -----------------------------------------------------
    //
    //                 Private Methods
    //
    // -----------------------------------------------------

    return person;
};



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/models/adaptors/legacyAccountPersonAdaptor.js
// module id = 203
// module chunks = 0